export default __webpack_public_path__ + "img/archive.cbd2a657.svg";